export default "__VITE_ASSET__uOMoNEkL__"